import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

// Theme
import { theme } from './styles/theme.styled';

const DarksideLayout = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

DarksideLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DarksideLayout;
